import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="crate"
export default class extends Controller {
  static targets = ["badge", "tooltip", "list", "bounce"];

  connect() {
    this.#updateCount();
    this.#updateTooltip();
    this.#updateList();
  }

  // Called from a button inside the menu, or by the walk through a window event.
  add({ params, detail }) {
    const labelId = params.labelId ?? detail?.labelId;
    if (this.crate.length === 0) {
      localStorage.setItem(
        "current_crate",
        JSON.stringify([...new Set([labelId])]),
      );
    } else {
      localStorage.setItem(
        "current_crate",
        JSON.stringify([...new Set(this.crate.concat([labelId]))]),
      );
    }

    this.#updateCount();
    this.#updateTooltip();
    this.#updateList();
    this.#bounce();
  }

  clear() {
    localStorage.removeItem("current_crate");
    this.#updateCount();
    this.#updateTooltip();
    this.#updateList();
  }

  // Decorative, so it stays still for anyone who asked for less motion.
  #bounce() {
    if (
      !this.hasBounceTarget ||
      matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    this.bounceTarget.play = true;
  }

  #updateCount() {
    this.badgeTarget.innerHTML = this.crate.length;
  }

  #updateTooltip() {
    this.formParams = new URLSearchParams("variant=tooltip");

    this.#prepareLabelsForForm();

    this.tooltipTarget.innerHTML = `<turbo-frame id="crate-tooltip" loading="lazy" src="/crates/new?${this.formParams.toString()}"><wa-spinner></wa-spinner></turbo-frame>`;
  }

  #updateList() {
    this.formParams = new URLSearchParams("variant=list");
    const url = new URL(this.listTarget.src, location.href);
    this.#prepareLabelsForForm();

    url.search = this.formParams.toString();

    this.listTarget.src = url.toString();
  }

  prepareFormSubmission({ detail: { formSubmission } }) {
    this.formParams = formSubmission.fetchRequest.fetchOptions.body;

    this.#prepareLabelsForForm();

    formSubmission.fetchRequest.fetchOptions.body = this.formParams;
  }

  cleanupAfterFormSubmission({ detail: { success } }) {
    if (success) this.clear();
  }

  #prepareLabelsForForm() {
    for (const label of this.crate) {
      this.formParams.append("crate[label_ids][]", label);
    }
  }

  get crate() {
    return JSON.parse(localStorage.getItem("current_crate")) || [];
  }
}
